import {
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  EventEmitter
} from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';

@Component({
    selector: 'table-cell-view-mode',
    template: `
    <div [ngSwitch]="cell.getColumn().type">
      <custom-view-component
        *ngSwitchCase="'custom'"
        [cell]="cell"
      ></custom-view-component>
      <div *ngSwitchCase="'html'" [innerHTML]="cell.newValue"></div>
      <div *ngSwitchDefault style="word-break: break-all;">
        <ng-container *ngIf="!hideLink()">
          <a href="#" (click)="onLinkClick($event)">
            {{ cell.getInitialValue() }}</a
          ></ng-container
        >
        <ng-container *ngIf="hideLink()">
          {{ cell.getInitialValue() }}
        </ng-container>
      </div>
    </div>
  `,
    standalone: false
})
export class ViewCellComponent {
  @Input() public cell: Cell;
  @Output() public linkClickEvent = new EventEmitter<any>();
  constructor() {
    // empty
  }
  public hideLink(): boolean {
    if (this.cell.getColumn().title === 'Action') {
      if (this.cell.getInitialValue().indexOf('Office Update(') === -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  public onLinkClick(event: any) {
    event.preventDefault();
    this.linkClickEvent.emit();
  }
}